<template>
    <div class="modal-header">
        <h4 class="modal-title">
            Seleccione una disposición
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card-body">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Folio de Disposición</th>
                        <th>Folio del Prospecto</th>
                        <th>Folio de Solicitud</th>
                        <th>Nombre</th>
                        <th>Tipo de persona</th>
                        <th>Fecha de creación</th>
                        <th>Score</th>
                        <th>Monto autorizado</th>
                        <th>Estatus</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in getDataPage()" :key="item.id" v-if="getDataPage().length != 0"
                        @click="selectDisposition(item)">
                        <td class="sorting_1 dtr-control">{{ item.referenceNumber }}</td>
                        <td>{{ item.prospectus?.referenceNumber }}</td>
                        <td>{{ item.loanApplication?.referenceNumber }}</td>
                        <td>
                            <span v-if="item.prospectus?.generalInformation?.businessName">
                                {{ item.prospectus.generalInformation.businessName }}
                            </span>
                            <span v-else>
                                {{ item.prospectus?.generalInformation?.firstName }}
                                {{ item.prospectus?.generalInformation?.lastName }}
                                {{ item.prospectus?.generalInformation?.mothersMaidenName }}
                            </span>
                        </td>
                        <td>{{ item.prospectus?.personType?.name }}</td>
                        <td>{{ $filters.formatDate(item.createdAt) }}</td>
                        <td>{{ item.creditScore?.score }}</td>
                        <td>{{ item.loanApplication?.quotations?.creditAmount }}</td>
                        <td>{{ item.status?.name }}</td>
                    </tr>
                    <tr v-else>
                        <td colspan="9" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sortKey: '',
            sortOrder: 1,
        }
    },
    emits: ['selected-item', 'back-to-form'],
    props: {
        list: {
            type: Array,
            default: () => [],
            required: true
        },
        itemsPerPage: {
            type: Number,
            default: () => 10,
        },
        currentPage: {
            type: Number,
            default: () => 1
        }
    },
    computed: {
        getDispositions() {
            return this.list;
        },
        sortedData() {
            let sortedList = [...this.list];
            if (this.sortKey) {
                sortedList.sort((a, b) => {
                    // Caso especial para el nombre
                    if (this.sortKey === 'name') {
                        const getNameForSort = (item) => {
                            if (!item) return '';

                            if (item.prospectus?.generalInformation?.businessName) {
                                return item.prospectus.generalInformation.businessName.toLowerCase();
                            } else {
                                return `${item.prospectus?.generalInformation?.firstName || ''} ${item.prospectus?.generalInformation?.lastName || ''} ${item.prospectus?.generalInformation?.mothersMaidenName || ''}`.toLowerCase();
                            }
                        };

                        const aName = getNameForSort(a);
                        const bName = getNameForSort(b);
                        if (aName < bName) return -1 * this.sortOrder;
                        if (aName > bName) return 1 * this.sortOrder;
                        return 0;
                    }

                    // Ordenamiento normal para otras columnas
                    let aValue = this.getNestedValue(a, this.sortKey);
                    let bValue = this.getNestedValue(b, this.sortKey);

                    if (aValue < bValue) return -1 * this.sortOrder;
                    if (aValue > bValue) return 1 * this.sortOrder;
                    return 0;
                });
            }
            return sortedList;
        }
    },
    methods: {
        getDataPage() {
            if (!this.sortedData || this.sortedData.length === 0) {
                return [];
            }
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            let end = (this.currentPage * this.itemsPerPage);
            return this.sortedData.slice(start, end);
        },
        getNestedValue(obj, key) {
            return key.split('.').reduce((o, i) => o?.[i], obj);
        },
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1;
            } else {
                this.sortOrder = 1;
            }
            this.sortKey = key;
        },
        selectDisposition(disposition) {
            this.$emit('selected-item', disposition);
            this.$emit('back-to-form');
        }
    },
    created() {
        this.getDataPage();
    }
}
</script>